import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { ThemeService } from './shell/theme/theme.service';
import { WoOfflineBootstrapService } from './services/work-orders/offline/wo-offline-bootstrap.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [IonApp, IonRouterOutlet],
  template: '<ion-app><ion-router-outlet /></ion-app>',
})
export class App {
  /** Eager init — applies stored / system theme before first paint. */
  private readonly _theme = inject(ThemeService);
  private readonly _offlineBootstrap = inject(WoOfflineBootstrapService);

  constructor() {
    void this._offlineBootstrap.start();
  }
}
